export default __webpack_public_path__ + "static/media/RyanMatovu.7a873408.png";